import {Component} from '@angular/core';
import {LocalizationPipePipe} from '../../localization/control/localisation-pipe-pipe';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-home-page',
  imports: [
    LocalizationPipePipe,
    RouterLink
  ],
  templateUrl: './home-page.html',
  standalone: true,
  styleUrl: './home-page.scss'
})
export class HomePage {

}
